import React from 'react'

const SvgCheckbox = (props: React.SVGAttributes<SVGElement>) => (
  <svg width='2em' height='2em' viewBox='0 0 29 29' fill='none' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M24.112 7.962c0-1.26-1.074-2.32-2.452-2.32H7.731c-1.377 0-2.452 1.06-2.452 2.32v13.84c0 1.26 1.075 2.32 2.452 2.32h13.93c1.377 0 2.451-1.06 2.451-2.32V7.962zm-2.452-.72c.38 0 .73.3.73.72v13.84c0 .42-.35.72-.73.72H7.731c-.38 0-.729-.3-.729-.72V7.962c0-.42.35-.72.73-.72H21.66z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.793 10.93c.353.329.373.882.044 1.236l-5.96 6.625a.875.875 0 01-1.281 0l-3.04-3.414a.875.875 0 111.28-1.193l2.4 2.727 5.32-5.937a.875.875 0 011.236-.045z'
      fill='currentColor'
    />
  </svg>
)

export default SvgCheckbox
